import { GroupRolesComponent } from './GroupRoles.types';
import { useMemo } from 'react';
import { CellProps } from '../GroupUsers/GroupUsers.types';
import { RoleBindingDto } from '../../../../api-client';
import { RowActions } from '../../../../common/components/RowActions/RowActions';
import { BusinessUnits } from '../BusinessUnits/BusinessUnits';
import { GroupRolesWrapper, StyledIcon } from './GroupRoles.styles';
import { RichTable } from 'common';
import { TableData } from '@hiiretail/synergy-ui/dist/types/components/surfaces/Table/Table.types';

export const GroupRoles: GroupRolesComponent = ({
  roles,
  isLoading,
  fetchError,
  refetchGroupRoles,
  setGroupRoleToDelete,
  setBuToDelete,
  onRoleClick,
  onAddButtonClick,
  openAddBusinessUnitModal,
}) => {
  const handleRemoveRoleFromGroup = (original: RoleBindingDto) => {
    setGroupRoleToDelete(original);
  };

  const tableColumns = useMemo(
    () => [
      { Header: 'Role id', accessor: 'roleId' },
      {
        Header: 'Resources',
        Cell: ({ row: { original } }: CellProps<RoleBindingDto>) => (
          <BusinessUnits
            role={original}
            openAddBusinessUnitModal={openAddBusinessUnitModal(original)}
            setBuToDelete={setBuToDelete}
          />
        ),
      },
      {
        Header: 'Actions',
        Cell: ({ row: { original } }: CellProps<RoleBindingDto>) => (
          <RowActions
            original={original}
            setItemToUpdate={() => void 0}
            toggleUpdateItemModal={() => void 0}
            onUpdateButtonClick={handleRemoveRoleFromGroup}
            disabled={false}
          >
            <StyledIcon />
          </RowActions>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <GroupRolesWrapper container item>
      <RichTable
        id="group-roles"
        title="Group roles"
        columns={tableColumns}
        data={roles as (RoleBindingDto & TableData)[]}
        isLoading={isLoading}
        fetchError={fetchError}
        refetch={refetchGroupRoles}
        errorSubject="group roles"
        searchFieldLabel=""
        onRowClick={onRoleClick}
        onSearchChange={() => void 0}
        permissions={{
          list: 'iam.group.list-roles',
          create: 'iam.group.assign-role',
        }}
        hideSearch
        createButtonTitle="Add role"
        onCreateButtonClick={onAddButtonClick}
        createButtonPermission="iam.group.assign-role"
      />
    </GroupRolesWrapper>
  );
};
